export default {
    user_not_active: 'Korisnik nije aktivan ili ne postoji',
    fields: {
        user_id: {
            label: 'Unesite id korisnika kog želite da aktivirate',
            placeholder: 'Unesite id ovde',
        },
    },
}
